module.exports = __webpack_public_path__ + "static/img/李纪灵 (2).6a1ef74d.png";